// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import moment from 'moment'

import routes from './routes'
import store from './store'
import Paginator from './components/Paginator'
import FuzzySearch from './components/FuzzySearch'
import SortableColumn from './components/shared/SortableColumn'

import './assets/main.scss'

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(ElementUI, { locale })
Vue.component('paginator', Paginator)
Vue.component('fuzzy-search', FuzzySearch)
Vue.component('sortable-column', SortableColumn)

const API_VER = process.env.API_VER

const router = new VueRouter({
  // mode: 'history',
  routes
})

/* eslint-disable no-new */
const vue = new Vue({
  el: '#app',
  template: ' <router-view></router-view>',
  router,
  store
})

function apiInterceptor (config) {
  config.headers['Accept'] = `${config.headers.common['Accept']}, application/vnd.motocompano.api+json;version=${API_VER}`
  return config
}

function authInterceptor (config) {
  const token = store.state.auth.token
  if (token) {
    config.headers[store.state.auth.tokenHeaderKey] = token
  }
  return config
}

function unauthorizedInterceptor (error) {
  const response = error.response
  if (response.status === 401 && !isLoginRequest(response)) {
    store.dispatch('auth/logout').then(() => {
      vue.$message({
        message: 'You have been logged out due to session timeout. Please login again.',
        type: 'warning',
        showClose: true
      })
      router.push('/login')
    })
  } else if (response.status) {
    vue.$message({
      message: `API Error. ${response.status} ${response.statusText}.`,
      type: 'error',
      showClose: true
    })
  }
  return Promise.reject(error)
}

function isLoginRequest (response) {
  return response.config.method === 'post' && response.config.url.endsWith('auth/login')
}

axios.interceptors.request.use(apiInterceptor)
axios.interceptors.request.use(authInterceptor)
axios.interceptors.response.use(null, unauthorizedInterceptor)

moment.locale(navigator.languages || navigator.language)



// WEBPACK FOOTER //
// ./src/main.js